
import Vue, { PropType } from 'vue';
import { VFairPavilion, VFairPavilionGroup } from '~/services/types/vfair';
import VFairService from '~/services/VFairService';
import URLS from '~/URLS';
import PavilionGroup from './PavilionGroup.vue';

export default Vue.extend({
    name: 'Pavilions',
    components: {
        PavilionGroup,
    },
    props: {
        loading: {
            type: Boolean,
            required: true,
        },
        vFairID: {
            type: String,
            required: true,
        },
        pavilions: {
            type: Array as PropType<VFairPavilion[]>,
            required: true,
        },
    },
    data() {
        return {
            pavilionGroups: [] as VFairPavilionGroup[],
            pavilionsLoading: true,
        };
    },
    computed: {
        isLoading(): boolean {
            return this.loading || this.pavilionsLoading;
        },
        enterButtonCaption(): string {
            return !!this.pavilions.length
                ? this.$t('components.navigation.allBooths').toString()
                : this.$t('vfair.enterEvent').toString();
        },
        groups(): VFairPavilionGroup[] {
            const uncategorizedId = 'uncategorizedGeneral';

            const uncategorized: VFairPavilionGroup = {
                id: uncategorizedId,
                vFairId: this.vFairID,
                orderPriority: -1,
                title: this.$t('vfair.general').toString(),
                pavilions: [] as VFairPavilion[],
            };

            const groupsById: Record<string, VFairPavilionGroup> = {
                [uncategorizedId]: uncategorized,
                ...this.pavilionGroups.reduce<Record<string, VFairPavilionGroup>>((acc, cur) => {
                    acc[cur.id] = {
                        ...cur,
                        pavilions: [],
                    };
                    return acc;
                }, {}),
            };

            for (const pavilion of this.pavilions)
                if (groupsById.hasOwnProperty(pavilion.groupId))
                    groupsById[pavilion.groupId].pavilions.push(pavilion);
                else groupsById[uncategorizedId].pavilions.push(pavilion);

            return Object.values(groupsById).sort((a, b) => a.orderPriority - b.orderPriority);
        },
    },
    methods: {
        fetchPavilionData() {
            this.pavilionsLoading = true;
            VFairService.getPavilionGroups(this.vFairID)
                .then(res => (this.pavilionGroups = res.data))
                .finally(() => (this.pavilionsLoading = false));
        },
        gotoPavilion() {
            this.$router.push(`${URLS.vfair}/${this.vFairID}`);
        },
    },
    mounted() {
        this.fetchPavilionData();
    },
});
